import React, {useEffect} from 'react';
import {Box, TablePagination} from "@mui/material";
import CustomSearch from "../components/common/CustomSearch";
import CustomSelect from "../components/common/CustomSelect";
import SearchComponent from "../components/searchComponent/SearchComponent";
import DoctorTable from "../components/doctor/DoctorTable";
import {useAppDispatch, useTypedSelector} from "../store";
import {useFormik} from "formik";
import {IGetDoctorsFilter} from "../store/rtk-api/doctor/types";
import {clearFilterData, clearFilterQuery, setFilterData} from "../store/doctors/doctors.slice";

const types = [
    {
        name: "все",
        value: 'all'
    },
    {
        name: "Опубликован",
        value: "true"
    },
    {
        name: "Не опубликован",
        value: "false"
    },
]


const Doctor = () => {
    const dispatch = useAppDispatch()
    // Filter actions
    const [page, setPage] = React.useState(0);
    const {query, is_active} = useTypedSelector(state => state.doctor)
    const formik = useFormik<IGetDoctorsFilter>({
        enableReinitialize: true,
        initialValues: {
            query: query || '',
            is_active: is_active || 'all',
        },
        onSubmit: (values) => {
            dispatch(setFilterData({page: undefined, query: values.query, is_active: values.is_active}))
        }
    })
    const {handleChange, values, handleSubmit, setFieldValue} = formik
    const handleClear = () => {
        dispatch(clearFilterData())
        setFieldValue('query', '')
    }
    // Pagination actions

    useEffect(() => {
        dispatch(setFilterData({page: page + 1}))
        dispatch(clearFilterQuery())
    }, [page])

    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const {doctorCount} = useTypedSelector(state => state.calendar)

    const children = (
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                <div style={{marginRight: "20px"}}>
                    <CustomSearch field={"query"} handleChange={handleChange} placeholder={"Врач, услуга, процедура"}
                                  width={"300px"} name={"query"} values={values} handleSubmit={handleSubmit}
                                  handleClear={handleClear}/>

                </div>
                <div style={{marginRight: "10px"}}>
                    <CustomSelect handleChange={handleChange} width={"100px"} value={values.is_active}
                                  name={"is_active"} items={types} height={"40px"} handleSubmit={handleSubmit}/>
                </div>
            </div>
            <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={
                    doctorCount || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage=""
                sx={{marginBottom: "10px"}}
            />

        </Box>
    )

    return (
        <>
            <SearchComponent children={children}/>
            <DoctorTable rowsPerPage={rowsPerPage}/>
        </>
    );
};

export default Doctor;